export default (value: unknown): value is Date => value instanceof Date;
